<template>
  <div class="counselling">
    <mainPage  :menus="menus"
               :propActiveMenu.sync="activeMenu">
      <el-card>
        <el-form ref="formData" 
                 :rules="rules"
                 :model="formData" label-width="120px">
          <el-tabs v-model="sigleTab">
            <el-tab-pane label="联盟咨询" name="first">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="标题名称：" prop="name">
                    <el-input v-model="formData.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="内容描述：" prop="content">
                    <el-input type="textarea" v-model="formData.content"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="是否公开：">
                    <el-radio-group v-model="formData.isPublic">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>

          <el-tabs v-model="sigleTab">
            <el-tab-pane label="企业信息" name="first">
               <el-row>
                <el-col :span="16">
                  <el-form-item label="企业名称：" prop="company">
                    <el-input v-model="formData.company"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="所属地区：" prop="areaData">
                    <el-cascader :options="cityData"
                                :props="{ value: 'label', checkStrictly: true, expandTrigger: 'hover' }"
                                clearable
                                v-model="formData.areaData"
                                style="width: 100%"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="注册地址：" prop="address">
                    <el-input v-model="formData.address"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="联系人：" prop="contact">
                    <el-input v-model="formData.contact"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="手机号：" prop="phone">
                    <el-input v-model="formData.phone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>

          <el-form-item>
            <el-button type="primary" 
                       @click="onSubmit" 
                       style="width: 180px"
                       :loading="loadState">提交</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <el-card style="margin-top: 20px">
        <el-tabs v-model="sigleTab">
            <el-tab-pane label="全部咨询" name="first">
              <div class="tab_input">
                <el-input placeholder="请输入关键字" 
                          v-model="search" 
                          @change="getCounselling"
                          clearable>
                  <template slot="append"><span @click="getCounselling">搜索</span> </template>
                </el-input>
              </div>
              <div v-if="!counselling.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
              <div v-for="item in counselling" :key="item.id" class="counselling_item">
                <div class="qustion">
                  <div class="label"><span>Q</span></div>
                  <div class="content">{{item.name}}</div>
                </div>
                <div class="answer">
                  <div class="label"><span>A</span></div>
                  <div class="content">
                    <div class="article-content"
                          v-html="item.reply">
                    </div>
                  </div>
                </div>
              </div>

              <div class="more_btn">加载更多 <i class="iconfont icon-shuaxin"></i></div>
            </el-tab-pane>
        </el-tabs>
      </el-card>
    </mainPage>
  </div>
</template>

<script>
import mainPage from './layout/main-page'
import myTable from './components/table'
import cityData from '@/assets/js/cityData'

export default {
  name: 'counselling',
  components: { 
    mainPage,
    myTable
  },
  data () {
    return {
      counselling: [],
      search: '',
      cityData,
      rules: {
        name: { required: true, message: '请输入标题', trigger: 'blur' },
        content: { required: true, message: '请输入描述', trigger: 'blur' },
        areaData: { required: true, type: 'array', message: '请选择地区', trigger: 'change' },
        company: { required: true, message: '请输入企业名称', trigger: 'blur' },
        contact: { required: true, message: '请输入联系人', trigger: 'blur' },
        phone: { required: true, message: '请输入手机号', trigger: 'blur' },
      },
      formData: {
        isPublic: false,
        areaData: []
      },
      sigleTab: 'first',
      pageSize: 10,
      pageCount: 1,
      total: 10,
      menus: [
        {value: '1', label: '展会通知', path: '/interaction'},
        {value: '2', label: '联盟咨询', path: '/consulting'},
      ],
      activeMenu: '2',
      loadState: false
    }
  },
  filters: {
  },
  computed: {
    localeLang: {
      get () { return this.$store.state.common.localeLang },
    }
  },
  watch: {
  },
  mounted () {
    this.getCounselling()
  },
  methods: {
    onSubmit () {
      this.loadState = false
      let valid = false
      this.$refs['formData'].validate((val) => {
        valid = val
      })
      if (!valid) {
        this.$message.error('输入内容不符合规范，请检查')
        return
      }
      let submitData = _.cloneDeep(this.formData)
      submitData.province = submitData.areaData[0]
      submitData.city = submitData.areaData[1]
      submitData.area = submitData.areaData[2]
      submitData.lang = this.localeLang
      delete submitData.areaData
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/consult/add'),
        method: 'post',
        data: submitData
      }).then((res) => {
        if (res.data.code === 'C0000') {
          this.$message.success(res.data.message)
          this.formData = {
            isPublic: false,
            areaData: []
          }
        }
      }).finally(() => {
        this.loadState = false
      })
    },
    getCounselling () {
      this.loadState = true
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/consult/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 5,
          data: {
            lang: this.localeLang
          },
          params: {
            $OR: {
              name$LIKE: this.search,
              reply$LIKE: this.search
            }
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.counselling = res.data.result.list || []
        }
      }).finally(() => {
        this.loadState = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.counselling{
  .counselling_item:last-child{
    border-bottom: none;
  }
  .more_btn{
    margin: auto;
    width: 220px;
    height: 40px;
    text-align: center;
    line-height: 38px;
    border: 1px solid #409EFF;
    color: #409EFF;
    margin-top: 20px;
    cursor: pointer;
  }
  .counselling_item{
    padding: 20px 0;
    border-bottom: 1px solid #eee;
    .qustion{
      .label{
        span{
          background: #dd1a28;
        }
      }
      .content{
        color: #535450;
      }
    }
    .answer{
      margin-top: 16px;
      .label{
        span{
          background: #255aa6;
        }
      }
      .content{
        background: #f6f6f6;
        padding: 16px;
        color: #61615d;
      }
    }
    .qustion, .answer{
      display: flex;
      .label{
        margin-right: 14px;
        padding: 2px;
        span{
          display: inline-block;
          width: 18px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          border-radius: 4px;
          color: #fff;
        }
      }
      .content{
        flex: 1;
        line-height: 24px;
      }
    }
  }
}
</style>
<style lang="scss">
.counselling{
  .el-input-group__append{
    cursor: pointer;
    background: #409EFF;
    color: #fff;
    span{
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/consulting.vue